export const TAG_PRESCRIPTION = 'global/prescription'
export const TAG_EYEGLASSES = 'global/eyeglasses'
